export default __webpack_public_path__ + "static/media/chile-icon.972418e9.svg";